import { cn } from 'lib/helpers/utility';

const Hr = ({ className }) => (
  <div className={cn('my-6 h-[1px] w-full bg-neutral-200', className)} />
);

export default Hr;
